import { useState, useEffect } from "react";

const useScroll = (handleScrollDirectionChanged) => {
  const [scrollDirection, setScrollDirection] = useState(0);
  const [scrollPosition, setSrollProsition] = useState(0);

  const handleScrollPositionChanged = () => {
    if (scrollPosition > 120) {
      setScrollDirection(-1);
    } else if (scrollPosition < -120) {
      setScrollDirection(1);
    }
  };

  useEffect(() => {
    handleScrollPositionChanged();
    const timer = setTimeout(() => {
      setSrollProsition(0);
    }, 300);
    return () => {
      clearTimeout(timer);
    };
  }, [scrollPosition]);

  useEffect(() => {
    handleScrollDirectionChanged(scrollDirection);
    const timer = setTimeout(() => {
      setScrollDirection(0);
    }, 500);
    return () => {
      clearTimeout(timer);
    };
  }, [scrollDirection]);

  const handleNavigation = (event) => {
    setSrollProsition((prev) => prev + event.deltaY);
  };

  return [handleNavigation];
};

export default useScroll;
